// export const API_BASE_URL = "http://18.139.175.66" // DEV
// export const API_BASE_URL = 'http://18.142.24.225'; //FOR TESTING

export const API_BASE_URL = 'https://pk9blqxffi.execute-api.us-east-1.amazonaws.com'; // DEV
export const API_BASE_URL_2 = 'https://z42wre5ee1.execute-api.us-east-1.amazonaws.com'; // DEV
export const app_universal_link = 'https://xure-landing-page-fork-testing.vercel.app/open-app'; //DEV



// export const app_universal_link = 'https://links.xuredeal.com/open-app'; //LIVE
// export const API_BASE_URL = 'https://nmx9twqzg1.execute-api.ap-southeast-1.amazonaws.com'; // LIVE
// export const API_BASE_URL_2 = 'https://24c1tkvfsa.execute-api.ap-southeast-1.amazonaws.com'; // LIVE 2